import { AppPageFrame } from '../../../components/AppPageFrame';
import CoachDailyCommandBoard from './CoachDailyCommandBoard';
import CoachStudioHeader from './CoachStudioHeader';
import type { CoachStudioLandingProps } from './coachStudioTypes';

export default function CoachStudioLanding({
  workspaceName,
  roleLabel,
  modeOptions: _modeOptions,
  workTabLabel,
  directoryLabel,
  accessLabel,
  occurrences,
  programCount,
  coachDashboard,
  nextSessionDetail,
  nextSessionSlotFillers,
  isNextSessionLoading,
  activeCount,
  linkedAthleteCount,
  pendingInvitationCount,
  activeJoinCodeCount,
  provider,
  providerViews,
  providerContacts,
  onOpenCatalog,
  onOpenWork,
  onOpenDirectory,
  onOpenAccess,
  onManagePros,
  onNavigate,
}: CoachStudioLandingProps) {
  const displayName = workspaceName || 'Coach Studio';
  const hasStudents = linkedAthleteCount > 0;
  const hasSessions = occurrences.length > 0;
  const hasAccessStarted = activeJoinCodeCount > 0 || pendingInvitationCount > 0 || activeCount > 1;

  return (
    <AppPageFrame className="space-y-5">
      <CoachStudioHeader
        displayName={displayName}
        roleLabel={roleLabel}
        workTabLabel={workTabLabel}
        directoryLabel={directoryLabel}
        accessLabel={accessLabel}
        occurrenceCount={occurrences.length}
        programCount={programCount}
        linkedAthleteCount={linkedAthleteCount}
        activeJoinCodeCount={activeJoinCodeCount}
        hasStudents={hasStudents}
        hasSessions={hasSessions}
        hasAccessStarted={hasAccessStarted}
        provider={provider}
        coachDashboard={coachDashboard}
        onOpenCatalog={onOpenCatalog}
        onOpenWork={onOpenWork}
        onOpenDirectory={onOpenDirectory}
        onOpenAccess={onOpenAccess}
      />

      <CoachDailyCommandBoard
        workTabLabel={workTabLabel}
        directoryLabel={directoryLabel}
        accessLabel={accessLabel}
        occurrences={occurrences}
        programCount={programCount}
        coachDashboard={coachDashboard}
        nextSessionDetail={nextSessionDetail}
        nextSessionSlotFillers={nextSessionSlotFillers}
        isNextSessionLoading={isNextSessionLoading}
        activeCount={activeCount}
        linkedAthleteCount={linkedAthleteCount}
        pendingInvitationCount={pendingInvitationCount}
        activeJoinCodeCount={activeJoinCodeCount}
        provider={provider}
        providerViews={providerViews}
        providerContacts={providerContacts}
        onOpenCatalog={onOpenCatalog}
        onOpenWork={onOpenWork}
        onOpenDirectory={onOpenDirectory}
        onOpenAccess={onOpenAccess}
        onManagePros={onManagePros}
        onNavigate={onNavigate}
      />
    </AppPageFrame>
  );
}
